<template>
  <div class="p-5">
    <span class="text-black font-semibold text-[13px]">Workflow</span>

    <ol class="mt-3 leading-7 text-gray-800">
      <li
        v-for="(step, index) in workflowSteps"
        :key="index"
        :class="[
          { '[&>*]:!text-success font-semibold' : (index) < plan.workflowStep },
          { 'font-semibold [&_.in-progress]:!inline': (index) === plan.workflowStep },
        ]"
        class="align-center font-medium"
      >
        <FontAwesomeIcon
          :icon="faCheckCircle"
          class="text-gray-200 mr-2"
        />

        <span class="text-xs">
          {{ index }}. {{ step }}
        </span>

        <span class="in-progress hidden bg-warning text-white px-1.5 py-0.5 rounded text-2xs ml-2">
          in progress
        </span>
      </li>
    </ol>
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const props = defineProps({
  plan: {
    type: Object,
    default: () => ({}),
  },
});

const workflowSteps = [
  'Work in Progress',
  'Submission to Provincial and District/Metro DDM IGR structures for noting',
  'Work in Progress',
  'Published as Draft',
  'Submission to Municipal Councils for approval',
  'Work in Progress',
  'Council resolution uploaded',
  'Published as Final Draft',
  'Submission to Provincial Executive Council for endorsement',
  'PEC resolution uploaded',
  'Submission to Minister of COGTA for approval',
  'Ministerial approval uploaded',
  'Submission to Cabinet for adoption',
  'Cabinet resolution uploaded',
  'Published as final',
];
</script>
